import http from "../util/http-common";
import {authHeader} from "../util/auth-header";

export class DataPublishService {
    static async getAll() {
        return http.get("/cfadminvinadmin/api/v1/publish", {headers: await authHeader()});
    }

    static async publish() {
        return http.post("/cfadminvinadmin/api/v1/publish", {}, {headers: await authHeader()});
    }
}

export default DataPublishService;